import { FC } from 'react'

import Button from 'components/forms/Button'
import { generateSrcSet } from 'project/image-proxy-web'

const Step = ({
  title,
  description,
  image,
  step,
}: {
  title: string
  description: string
  image: string
  step: number
}) => {
  return (
    <div
      className='card rounded-box col-12 col-lg-3 h-100 d-flex flex-column flex-fill'
      style={{
        minHeight: 480,
      }}
    >
      <img
        className='rounded-box w-100 h-auto'
        {...generateSrcSet(image, 315, 228)}
        height={228}
        width={315}
        style={{
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
        }}
      />

      <div className='d-flex flex-column mt-10 px-5 flex-grow-1'>
        <span className='fs-20 fw-semibold color-grey5'>STEP {step}</span>
        <span className='fs-24 fw-bold'>{title}</span>
        <span className='fs-18 color-grey5 fw-semibold pb-4'>
          {description}
        </span>
      </div>
    </div>
  )
}

const steps = [
  {
    image: '/images/new/whatsapp/choose-number.png',
    title: 'Get your number',
    description:
      "Setup your subscription and we'll create your WhatsApp for Business number from Hoxton Mix",
  },
  {
    image: '/images/new/whatsapp/download.png',
    title: 'Download the app',
    description: 'Download the WhatsApp Business app (iOS or Android)',
  },
  {
    image: '/images/new/whatsapp/verify.png',
    title: 'Verify your number',
    description: 'Verify your new number inside the app',
  },
  {
    image: '/images/new/whatsapp/configure.png',
    title: 'Configure your profile',
    description:
      'Configure your business profile and automated messages using our quick-start guides',
  },
]

type Props = {
  onBuyNow: () => void
}

const WAGetStartedSteps: FC<Props> = ({ onBuyNow }) => {
  return (
    <div className='d-flex flex-column align-items-center align-self-center'>
      <div className='d-flex flex-column gap-3 text-center mb-17'>
        <h2 className='fs-fluid-36-80 lh-105 lh-lg-114 fw-semibold mb-0'>
          Get started in four easy steps:
        </h2>
        <div className='fs-fluid-18-24 fw-semibold color-grey5'>
          Choose your personalised Virtual Office WhatsApp for Business number
          from Hoxton Mix
        </div>
      </div>
      <div className='d-flex flex-column flex-lg-row flex-lg-nowrap gap-5 align-items-stretch justify-content-center'>
        {steps.map((step, i) => (
          <Step
            step={i + 1}
            image={step.image}
            key={step.title}
            title={step.title}
            description={step.description}
          />
        ))}
      </div>
      <Button onClick={onBuyNow} className='w-100 w-lg-auto mt-10'>
        Buy Now
      </Button>
    </div>
  )
}

export default WAGetStartedSteps
